// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3xHFF","rootSmall":"AddTileButton_rootSmall__3PyvV"};